import { render, staticRenderFns } from "./StorySlider.vue?vue&type=template&id=6716a1aa&"
import script from "./StorySlider.vue?vue&type=script&lang=js&"
export * from "./StorySlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports